var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-comment-cells"},_vm._l((_vm.columns),function(column){return _c('div',{key:'comment-total-' + column.column_id,staticClass:"list-comment-cell-item"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }